const DELETE_ANALYSE_RESPONSE = {
  OperationResult: 'OperationResult',
  TokenError: 'TokenError',
  NotFound: 'NotFound',
  Upload: 'Upload',
  Unauthorized: 'Unauthorized',
};

export default DELETE_ANALYSE_RESPONSE;
